"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/Setup/SetupGroups/Video.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _VideoFeed = require('web/components/VideoCall/VideoFeed'); var _VideoFeed2 = _interopRequireDefault(_VideoFeed);
var _videoCall = require('web/services/videoCall');








const VideoSetupGroup = ({
  videoStream,
  videoInDevices,
  currentCamDeviceId,
  setCurrentCamDeviceId,
}) => {
  const handleCamChange = (e) =>
    setCurrentCamDeviceId(e.target.value)

  const areAnyDevicesPresent = videoInDevices && videoInDevices.length

  return (
    _react2.default.createElement('div', { className: "meeting--setup--group", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}
      , _react2.default.createElement('div', { className: "meeting--setup--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}
        , _react2.default.createElement('h3', { className: "meeting--setup--section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}, "Camera")
        , _react2.default.createElement('div', { className: "meeting--setup--section-main", __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}
          , _react2.default.createElement('select', {
            value: currentCamDeviceId,
            onChange: handleCamChange,
            className: "meeting--setup--select",
            disabled: !areAnyDevicesPresent, __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}

            ,  areAnyDevicesPresent
              ? videoInDevices.map(({ deviceId, label }, i) => (
                  _react2.default.createElement('option', {
                    key: deviceId,
                    value: deviceId, __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}

                    ,  label || `Camera #${i + 1}` 
                  )
              ))
              : _react2.default.createElement('option', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}, "N/A")
            
          )
        )
        , _react2.default.createElement('div', { className: "meeting--setup--feed-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
          , _react2.default.createElement(_VideoFeed2.default, {
            shouldMirror: _videoCall.shouldMirrorCamFeed.call(void 0, videoStream),
            stream: videoStream,
            className: "meeting--setup--feed", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
          )
        )
      )
    )
  )
}

exports. default = VideoSetupGroup
